import type { ReactNode } from "react";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import { useLocation } from "react-router";
import { LinkButton } from "../components/ui";

export function NotFound(): ReactNode {
  const location = useLocation();
  return (
    <Container style={{ maxWidth: "34rem" }}>
      <Card>
        <Card.Body className="p-4 p-md-5 text-center">
          <p className="emb-eyebrow mb-2">404</p>
          <h1 className="h4 mb-2">There is nothing at this address</h1>
          <p className="emb-muted">
            <code className="emb-url">{location.pathname}</code> is not a page on this site.
          </p>
          <div className="d-flex gap-2 justify-content-center">
            <LinkButton to="/">Go home</LinkButton>
            <LinkButton to="/connect" variant="outline-primary">
              Connect an assistant
            </LinkButton>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
